var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.170639,
    width: 23,
    height: 22.0417,
    rx: 4.6,
    fill: "#001B4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9369 7.59889C18.5544 8.16866 18.5544 9.09253 17.9369 9.66229L10.4938 16.5302L6.21313 12.5804C5.59562 12.0106 5.59562 11.0868 6.21313 10.517C6.83066 9.94724 7.83185 9.94724 8.44938 10.517L10.4938 12.4034L15.7007 7.59889C16.3182 7.02913 17.3194 7.02913 17.9369 7.59889Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedNew);
export default __webpack_public_path__ + "static/media/checked-new.fc832e560db8961cb00d28efe79bae7a.svg";
export { ForwardRef as ReactComponent };